import { type ReactNode, forwardRef } from 'react';

import { Button } from '@spotify-internal/encore-web';
import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';
import { MenuTriggerPlusIcon } from '@spotify/confidence-core-react';

export type PageHeaderCreateButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
  disabledReason?: ReactNode;
  isVisuallyDisabled?: boolean;
  'aria-disabled'?: boolean;
  'data-testid'?: string;
  children?: ReactNode;
};

export const HeaderCreateButton = forwardRef<
  HTMLButtonElement,
  PageHeaderCreateButtonProps
>(
  (
    {
      onClick,
      disabled,
      disabledReason,
      isVisuallyDisabled,
      'aria-disabled': ariaDisabled,
      children = 'Create',
      ...rest
    },
    ref,
  ) => {
    const showDisabledReason = Boolean(disabled && disabledReason);
    const button = (
      <Button
        ref={ref}
        variant="primary"
        onClick={ariaDisabled || showDisabledReason ? undefined : onClick}
        disabled={disabled && !showDisabledReason}
        isVisuallyDisabled={isVisuallyDisabled || showDisabledReason}
        aria-disabled={ariaDisabled || showDisabledReason}
        data-track-source-anchor="2736e97a7e;header-create-button" {...rest}
      >
        <MenuTriggerPlusIcon />
        {children}
      </Button>
    );

    if (!showDisabledReason) return button;

    return (
      <TooltipRoot>
        {button}
        <Tooltip>{disabledReason}</Tooltip>
      </TooltipRoot>
    );
  },
);

HeaderCreateButton.displayName = 'HeaderCreateButton';
